import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HistoryDocumentDetailsBaseRow } from "../utils/historyDocumentDetailsRow";

interface HistoryDocumentFinancialAccountCellProps {
    row: { original: HistoryDocumentDetailsBaseRow };
}

export const HistoryDocumentFinancialAccountCell = memo(
    ({ row }: HistoryDocumentFinancialAccountCellProps) => {
        const { financialAccountId, financialAccountName } = row.original;
        const accounts = useFinancialAccounts();

        if (financialAccountId === null) {
            return (
                <ViewTableCell>
                    <EmptyValue />
                </ViewTableCell>
            );
        }

        const found = accounts?.find(
            (account) => account.id === financialAccountId,
        );

        if (!found) {
            return (
                <ViewTableCell>
                    <BreakableText
                        text={financialAccountName ?? ""}
                        showTooltip
                    />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <AccountCard account={found} showType={false} iconSize="sm" />
            </ViewTableCell>
        );
    },
);

HistoryDocumentFinancialAccountCell.displayName =
    "HistoryDocumentFinancialAccountCell";
